import React from 'react';
import { useTheme, Box } from '@chakra-ui/core';
import { IconContainer } from './index';

/**
 * The Instagram icon link
 * @param {string} The external link the icon points to
 */
export function Instagram({ link }) {
  const theme = useTheme();
  return (
    <IconContainer link={link}>
      <Box
        as="svg"
        xmlns="http://www.w3.org/2000/svg"
        h="75%"
        w="75%"
        viewBox="0 0 1792 1792"
        aria-labelledby="instagramTitle"
        role="img"
      >
        <title id="instagramTitle">A Instagram Icon SVG</title>
        <path
          fill={theme.footer.iconsFill}
          d="M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm138 0q0 164-115 279t-279 115-279-115-115-279 115-279 279-115 279 115 115 279zm108-410q0 38-27 65t-65 27-65-27-27-65 27-65 65-27 65 27 27 65zM896 266q-7 0-76.5-.5t-105.5 0-96.5 3-103 10T443 297q-50 20-88 58t-58 88q-11 29-18.5 71.5t-10 103-3 96.5 0 105.5.5 76.5-.5 76.5 0 105.5 3 96.5 10 103T297 1349q20 50 58 88t88 58q29 11 71.5 18.5t103 10 96.5 3 105.5 0 76.5-.5 76.5.5 105.5 0 96.5-3 103-10 71.5-18.5q50-20 88-58t58-88q11-29 18.5-71.5t10-103 3-96.5 0-105.5-.5-76.5.5-76.5 0-105.5-3-96.5-10-103T1495 443q-20-50-58-88t-88-58q-29-11-71.5-18.5t-103-10-96.5-3-105.5 0-76.5.5zm768 630q0 229-5 317-10 208-124 322t-322 124q-88 5-317 5t-317-5q-208-10-322-124t-124-322q-5-88-5-317t5-317q10-208 124-322t322-124q88-5 317-5t317 5q208 10 322 124t124 322q5 88 5 317z"
        ></path>
      </Box>
    </IconContainer>
  );
}
